"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPopover = require("@tencent/spaui-popover");

var _uploader = _interopRequireDefault(require("./uploader"));

var _mask_content_component = _interopRequireDefault(require("./component/imageuploader/mask_content_component"));

var _add_component = _interopRequireDefault(require("./component/imageuploader/add_component"));

var _empty_component = _interopRequireDefault(require("./component/imageuploader/empty_component"));

var _no_value_component = _interopRequireDefault(require("./component/imageuploader/no_value_component"));

var _img_content_component = _interopRequireDefault(require("./component/imageuploader/img_content_component"));

var _img_component = _interopRequireDefault(require("./component/imageuploader/img_component"));

var _display_component = _interopRequireDefault(require("./component/imageuploader/display_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isFunction = _spauiUtils.utils.isFunction,
    getVersion = _spauiUtils.utils.getVersion;
var ieVersion = getVersion();
var useFileAPI = ieVersion <= -1 || ieVersion >= 10;
/**
 * @class
 */

var ImageUploader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageUploader, _PureComponent);

  /**
   * 属性说明
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} [upload=true] 是否能够上传
   * @property {bool} [reupload=true] 是否支持重新上传
   * @property {bool} [required=false] 开启这个之后，将没有删除按钮
   * @property {string} [fileId] 指定"input type=file"的id
   * @property {bool} [autoUpload=true] 是否自动上传
   * @property {bool} [disabled=false] 是否禁用
   * @property {bool} [multiple=false] 是否多选
   * @property {bool} [drag=false] 是否支持拖拽
   * @property {string} [dragOverClassName=''] 拖动到区域添加的className(可用于拖动效果的样式处理)
   * @property {bool} [click=true] 是否支持点击上传
   * @property {string} [accept='*'] 选择的文件类型（<a href="https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Headers/Accept" target="_blank">参考配置</a>）
   * @property {func} [onFileChange] 文件变化即调用<br />onFileChange(event)
   * @property {titleline} 已上传数据属性
   * @property {string} [type=''] 上传类型,type=video为上传的是视频，其他为图片
   * @property {array} [value=[]] 已经上传的数据
   * @property {array} [uploadingValue=[]] 正在上传中的数据
   * @property {func} [onChange] 数据变更回调<br />onChange(event, value)
   * @property {func} [onDelete] 数据删除回调<br />onDelete(event, data)
   * @property {titleline} 触发上传属性
   * @property {string} [name=''] 字段名
   * @property {string} [url=''] 上传的url
   * @property {object} [data={}] 接口附带的数据
   * @property {object} [headers={}] 请求header参数
   * @property {func} [filter] 筛选文件（只适用于支持html5的）<br />filter(fileInfo, event)
   * @property {func} [check] 异步文件检查成功后，调用next继续上传<br />check(fileInfo, next) 检查成功后，调用next继续上传
   * @property {func} [canUpload] 是否能够触发上传<br />canUpload(event)
   * @property {func} [onUpload] 开始上传回调<br />onUpload(event, fileInfo)
   * @property {func} [onProgress] 上传过程回调<br />onProgress(progressEvent, fileInfo)
   * @property {func} [onComplete] 上传完成回调<br />onComplete(resp, fileInfo)
   * @property {titleline} 自定义属性
   * @property {func|element} [ItemAppendComponent] 附加组件结构*(具体参数看案例)*
   * @property {func|element} [AddComponent] 添加图片结构*(具体参数看案例)*
   * @property {func|element} [ImgComponent] 图片结构*(具体参数看案例)*
   * @property {func|element} [ImgContentComponent] 内容结构*(具体参数看案例)*
   * @property {func|element} [DisplayComponent] 展示Component*(具体参数看案例)*
   * @property {func|element} [EmptyComponent] 没有图片的结构*(具体参数看案例)*
   * @property {func|element} [MaskContentComponent] 遮罩层内容结构*(具体参数看案例)*
   * @example
   * &lt;ItemAppendComponent
   data={data}
  /&gt;
   *
   * &lt;AddComponent /&gt;
   *
   * &lt;ImgComponent
  onComplete={imageOnComplete}
  useFileAPI={useFileAPI}
  setUploader={this.setUploader}
  index={index}
  data={item}
  canDelete={canDelete}
  canReupload={canReupload}
  controls={controls}
  required={required}
  upload={upload}
  onDelete={(event) => {}}
  ItemAppendComponent={ItemAppendComponent}
  ImgContentComponent={ImgContentComponent}
  DisplayComponent={DisplayComponent}
  MaskContentComponent={MaskContentComponent}
  type={type}
  /&gt;
   *
   * &lt;ImgContentComponent
      useFileAPI={useFileAPI}
      type={type}
      upload={upload}
      className={className)}
      data={data}
      canDelete={canDelete}
      required={required}
      onDelete={onDelete}
      controls={controls}
      DisplayComponent={DisplayComponent}
      ItemAppendComponent={ItemAppendComponent}
      MaskContentComponent={MaskContentComponent}
  /&gt;
   *
   * &lt;DisplayComponent
      type={type}
      data={data}
      controls={controls}
  /&gt;
   *
   *&lt;EmptyComponent
      useFileAPI={useFileAPI}
      drag={drag}
  /&gt;
   *
   * &lt;MaskContentComponent
      type={type}
      upload={upload}
      useFileAPI={useFileAPI}
      onDelete={onDelete}
      data={data}
      canDelete={canDelete}
  /&gt;
   *
   */
  function ImageUploader(props) {
    var _this;

    _classCallCheck(this, ImageUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageUploader).call(this, props));

    _this.refList();

    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this));
    _this.handleComplete = _this.handleComplete.bind(_assertThisInitialized(_this));
    _this.setUploader = _this.setUploader.bind(_assertThisInitialized(_this));
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.state = {
      uploadingValue: props.uploadingValue || []
    };
    return _this;
  }

  _createClass(ImageUploader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.uploadingValue !== 'undefined') {
        this.setState({
          uploadingValue: nextProps.uploadingValue || []
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refList();
    }
  }, {
    key: "refList",
    value: function refList() {
      this.domRef = null;
      this.uploadRef = null;
    } // 进度

  }, {
    key: "handleProgress",
    value: function handleProgress(event, fileTarget, fileId) {
      var _this$props = this.props,
          onProgress = _this$props.onProgress,
          propsUploadingValue = _this$props.uploadingValue;
      var _this$state$uploading = this.state.uploadingValue,
          uploadingValue = _this$state$uploading === void 0 ? [] : _this$state$uploading;
      var newUploadingValue = [],
          haveUploadingValue = false;

      if (typeof propsUploadingValue === 'undefined') {
        uploadingValue.map(function (item) {
          if (item && item.id === fileId) {
            haveUploadingValue = true;
            newUploadingValue.push(_objectSpread({}, item, {
              progress: event.loaded / event.total * 100
            }));
          } else {
            newUploadingValue.push(item);
          }

          return item;
        });

        if (!haveUploadingValue) {
          newUploadingValue.push({
            id: fileId,
            name: fileTarget.name || '文件正在上传中',
            progress: event.loaded / event.total * 100
          });
        }

        this.setState({
          uploadingValue: newUploadingValue
        });
      }

      if (isFunction(onProgress)) {
        onProgress(event, fileTarget, fileId);
      }
    } // 上传完成回调

  }, {
    key: "handleComplete",
    value: function handleComplete(err, xhr) {
      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
      var fileId = arguments.length > 4 ? arguments[4] : undefined;
      var _this$props2 = this.props,
          onComplete = _this$props2.onComplete,
          propsUploadingValue = _this$props2.uploadingValue;
      var uploadingValue = this.state.uploadingValue;
      var newUploadingValue = [];

      if (typeof propsUploadingValue === 'undefined') {
        // 删除正在上传数据中的value
        uploadingValue.map(function (item) {
          if (item.id !== fileId) {
            newUploadingValue.push(item);
          }

          return item;
        });
        this.setState({
          uploadingValue: newUploadingValue
        });
      }

      if (isFunction(onComplete)) {
        onComplete(resp, fileTarget, fileId, xhr);
      }
    } // 删除图片

  }, {
    key: "handleDelete",
    value: function handleDelete(event, data, deleteIndex) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          onDelete = _this$props3.onDelete;
      var result = [],
          index = -1; // 删除第几张

      if (typeof deleteIndex !== 'undefined') {
        index = parseInt(deleteIndex, 10) || 0;
      } // 剩下的数据


      value.map(function (item, valueIndex) {
        if (valueIndex !== index) {
          result.push((0, _spauiUtils.objectAssign)(item));
        }

        return item;
      });

      if (isFunction(onChange)) {
        onChange(event, result);
      }

      if (isFunction(onDelete)) {
        onDelete(event, data);
      }

      event.stopPropagation();
    } // 获取上传输入框

  }, {
    key: "getInputDOMNode",
    value: function getInputDOMNode() {
      var result = null;

      if (this.uploadRef) {
        result = this.uploadRef.getInputDOMNode();
      }

      return result;
    } // 设置上传功能

  }, {
    key: "setUploader",
    value: function setUploader(children, config) {
      var _this2 = this;

      var _this$props4 = this.props,
          name = _this$props4.name,
          url = _this$props4.url,
          multiple = _this$props4.multiple,
          drag = _this$props4.drag,
          disabled = _this$props4.disabled,
          filter = _this$props4.filter,
          canUpload = _this$props4.canUpload,
          autoUpload = _this$props4.autoUpload,
          _this$props4$dragOver = _this$props4.dragOverClassName,
          dragOverClassName = _this$props4$dragOver === void 0 ? '' : _this$props4$dragOver,
          onUpload = _this$props4.onUpload,
          data = _this$props4.data,
          click = _this$props4.click,
          accept = _this$props4.accept,
          onFileChange = _this$props4.onFileChange,
          check = _this$props4.check,
          upload = _this$props4.upload,
          headers = _this$props4.headers,
          _this$props4$FileAPIC = _this$props4.FileAPIConfig,
          FileAPIConfig = _this$props4$FileAPIC === void 0 ? {} : _this$props4$FileAPIC,
          onKeyPress = _this$props4.onKeyPress,
          onKeyUp = _this$props4.onKeyUp,
          onKeyDown = _this$props4.onKeyDown,
          onMouseOver = _this$props4.onMouseOver,
          onMouseOut = _this$props4.onMouseOut,
          onMouseEnter = _this$props4.onMouseEnter,
          onMouseLeave = _this$props4.onMouseLeave,
          onClick = _this$props4.onClick,
          fileId = _this$props4.fileId;
      var props = (0, _spauiUtils.objectAssign)({
        disabled: disabled,
        multiple: multiple,
        drag: drag,
        dragOverClassName: dragOverClassName,
        name: name,
        url: url,
        data: data,
        onUpload: onUpload,
        filter: filter,
        click: click,
        accept: accept,
        autoUpload: autoUpload,
        canUpload: canUpload,
        onProgress: this.handleProgress,
        onComplete: this.handleComplete,
        onFileChange: onFileChange,
        check: check,
        fileId: fileId,
        headers: headers,
        FileAPIConfig: FileAPIConfig
      }, config);
      var result = null,
          eventMap = {
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick
      };

      if (disabled) {
        eventMap = {};
      }

      if (upload) {
        result = _react["default"].createElement(_uploader["default"], _extends({}, props, {
          ref: function ref(el) {
            _this2.uploadRef = el;
          }
        }), children);
      } else {
        result = (0, _react.cloneElement)(children, _objectSpread({}, eventMap, {
          disabled: disabled,
          multiple: multiple,
          drag: drag ? true : false
        }));
      }

      return result;
    } // 添加按钮

  }, {
    key: "genAddButton",
    value: function genAddButton() {
      var AddComponent = this.props.AddComponent;
      var child = null,
          result = null;

      if (typeof AddComponent !== 'undefined') {
        child = _react["default"].createElement(AddComponent, null);
        result = this.setUploader(child, {
          drag: false
        });
      }

      return result;
    } // 有数据的显示模块

  }, {
    key: "haveValueRender",
    value: function haveValueRender() {
      var _this3 = this;

      var _this$props5 = this.props,
          _this$props5$value = _this$props5.value,
          value = _this$props5$value === void 0 ? [] : _this$props5$value,
          count = _this$props5.count,
          onChange = _this$props5.onChange,
          disabled = _this$props5.disabled,
          ItemAppendComponent = _this$props5.ItemAppendComponent,
          ImgComponent = _this$props5.ImgComponent,
          ImgContentComponent = _this$props5.ImgContentComponent,
          controls = _this$props5.controls,
          reupload = _this$props5.reupload,
          MaskContentComponent = _this$props5.MaskContentComponent,
          required = _this$props5.required,
          upload = _this$props5.upload,
          type = _this$props5.type,
          DisplayComponent = _this$props5.DisplayComponent;
      var _this$state$uploading2 = this.state.uploadingValue,
          uploadingValue = _this$state$uploading2 === void 0 ? [] : _this$state$uploading2;
      var imgsClassName = (0, _classnames["default"])('imgs', {
        'imgs-more': count > 1
      });
      var result = [],
          showValue = [],
          valueRenderDom = null,
          finalDom = null,
          canAdd = false;
      value.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item));
        }

        return item;
      });
      uploadingValue.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item, {
            status: 'uploading'
          }));
        }

        return item;
      });

      if (count < 2) {
        result = [showValue[0]];
      } else {
        result = showValue;
      } // 有数量限制


      if (result.length > count) {
        if (isFunction(onChange)) {
          onChange({}, result.slice(0, count));
          return false;
        }
      }

      canAdd = !disabled && count > 1 && showValue.length < count;
      valueRenderDom = _react["default"].createElement("div", {
        className: "uper uped"
      }, _react["default"].createElement("div", {
        className: "imgarea"
      }, _react["default"].createElement("ul", {
        className: imgsClassName
      }, result.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var canDelete = !(typeof item["delete"] !== 'undefined' && !item["delete"]) && !disabled;
        var canReupload = reupload || false;
        var _item$popover = item.popover,
            popover = _item$popover === void 0 ? '' : _item$popover;

        var imageOnComplete = function imageOnComplete(resp, imageIndex, data, fileTarget, fileId, err, xhr) {
          _this3.handleComplete(err, xhr, resp, fileTarget, fileId);
        };

        if (typeof item.reupload !== 'undefined') {
          canReupload = item.reupload || false;
        }

        var child = _react["default"].createElement(ImgComponent, {
          onComplete: imageOnComplete,
          useFileAPI: useFileAPI,
          setUploader: _this3.setUploader,
          index: index,
          data: item,
          canDelete: canDelete,
          canReupload: canReupload,
          controls: controls,
          required: required,
          upload: upload,
          onDelete: function onDelete(event) {
            return _this3.handleDelete(event, item, index);
          },
          ItemAppendComponent: ItemAppendComponent,
          ImgContentComponent: ImgContentComponent,
          DisplayComponent: DisplayComponent,
          MaskContentComponent: MaskContentComponent,
          type: type
        });

        var itemResult = null,
            _popover = null;

        if (popover) {
          if (typeof popover === 'string') {
            _popover = _react["default"].createElement(_spauiPopover.PopOver, null, popover);
          } else {
            _popover = popover;
          }

          itemResult = _react["default"].createElement(_spauiPopover.OverlayTrigger, {
            key: index,
            trigger: "hover",
            placement: "top",
            overlay: _popover,
            hideDelayTime: 0
          }, child);
        } else {
          itemResult = (0, _react.cloneElement)(child, {
            key: index
          });
        }

        return itemResult;
      }), canAdd ? this.genAddButton() : null)));

      if (canAdd && upload) {
        finalDom = this.setUploader(valueRenderDom, {
          click: false
        });
      } else {
        finalDom = valueRenderDom;
      }

      return finalDom;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props6 = this.props,
          className = _this$props6.className,
          _this$props6$value = _this$props6.value,
          value = _this$props6$value === void 0 ? [] : _this$props6$value,
          drag = _this$props6.drag,
          NoValueComponent = _this$props6.NoValueComponent,
          EmptyComponent = _this$props6.EmptyComponent;
      var _this$state$uploading3 = this.state.uploadingValue,
          uploadingValue = _this$state$uploading3 === void 0 ? [] : _this$state$uploading3;
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-uploader', className),
        supportAllEvents: true
      }, ImageUploader, this.props), {
        ref: function ref(el) {
          _this4.domRef = el;
        }
      }), value.length + uploadingValue.length < 1 ? this.setUploader(_react["default"].createElement(NoValueComponent, {
        useFileAPI: useFileAPI,
        drag: drag,
        EmptyComponent: EmptyComponent
      })) : this.haveValueRender());
    }
  }]);

  return ImageUploader;
}(_react.PureComponent);

_defineProperty(ImageUploader, "propTypes", {
  count: _spauiUtils.PropTypes.number,
  value: _spauiUtils.PropTypes.array,
  uploadingValue: _spauiUtils.PropTypes.array,
  name: _spauiUtils.PropTypes.string,
  url: _spauiUtils.PropTypes.string,
  data: _spauiUtils.PropTypes.object,
  headers: _spauiUtils.PropTypes.object,
  disabled: _spauiUtils.PropTypes.bool,
  multiple: _spauiUtils.PropTypes.bool,
  reupload: _spauiUtils.PropTypes.bool,
  required: _spauiUtils.PropTypes.bool,
  upload: _spauiUtils.PropTypes.bool,
  drag: _spauiUtils.PropTypes.bool,
  dragOverClassName: _spauiUtils.PropTypes.string,
  filter: _spauiUtils.PropTypes.func,
  check: _spauiUtils.PropTypes.func,
  autoUpload: _spauiUtils.PropTypes.bool,
  onComplete: _spauiUtils.PropTypes.func,
  onChange: _spauiUtils.PropTypes.func,
  onDelete: _spauiUtils.PropTypes.func,
  onFileChange: _spauiUtils.PropTypes.func,
  ItemAppendComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  EmptyComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  AddComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ImgComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  DisplayComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ImgContentComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  NoValueComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  MaskContentComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
});

_defineProperty(ImageUploader, "defaultProps", {
  count: 1,
  value: [],
  name: '',
  url: '',
  data: {},
  headers: {},
  disabled: false,
  multiple: false,
  upload: true,
  drag: true,
  dragOverClassName: 'spaui-uploader-drag-over',
  reupload: true,
  required: false,
  autoUpload: true,
  filter: function filter() {
    return true;
  },
  EmptyComponent: _empty_component["default"],
  AddComponent: _add_component["default"],
  ImgComponent: _img_component["default"],
  ImgContentComponent: _img_content_component["default"],
  NoValueComponent: _no_value_component["default"],
  MaskContentComponent: _mask_content_component["default"],
  DisplayComponent: _display_component["default"]
});

var _default = ImageUploader;
exports["default"] = _default;